import styled from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 17px;
	padding: 17px 20px 20px;
	width: 380px;
	background: rgba(255, 255, 255, 0.02);
	border-radius: 10px;
`;

export { StyledContainer };
